document.addEventListener('DOMContentLoaded', () => {
  setSkincareRitualHeaderHeight();
  initSkincareRituals();
});

window.addEventListener('load', () => {
  setSkincareRitualHeaderHeight();
});

window.addEventListener('resize', debounceSkincareRitual(() => {
  setSkincareRitualHeaderHeight();

  document.querySelectorAll('[data-skincare-ritual]').forEach((section) => {
    updateSkincareRitual(section);
  });
}, 100));

document.addEventListener('shopify:section:load', (event) => {
  setSkincareRitualHeaderHeight();

  const section = event.target.querySelector('[data-skincare-ritual]');

  if (section) {
    initSkincareRitual(section);
  }
});

function setSkincareRitualHeaderHeight() {
  const header = document.querySelector(
    '.custom-header.custom-header--fixed'
  );

  if (!header) {
    document.documentElement.style.setProperty(
      '--home-ritual-header-height',
      '0px'
    );
    return;
  }

  const headerHeight = header.getBoundingClientRect().height;

  document.documentElement.style.setProperty(
    '--home-ritual-header-height',
    `${headerHeight}px`
  );
}

function initSkincareRituals() {
  document.querySelectorAll('[data-skincare-ritual]').forEach((section) => {
    initSkincareRitual(section);
  });
}

function initSkincareRitual(section) {
  if (section.dataset.ritualInitialized === 'true') {
    return;
  }

  section.dataset.ritualInitialized = 'true';

  const slider = section.querySelector('[data-ritual-slider]');

  if (!slider) {
    return;
  }

  slider.addEventListener(
    'scroll',
    () => {
      requestAnimationFrame(() => {
        updateSkincareRitual(section);
      });
    },
    { passive: true }
  );

  updateSkincareRitual(section);
}

function updateSkincareRitual(section) {
  const slider = section.querySelector('[data-ritual-slider]');
  const cards = Array.from(
    section.querySelectorAll('[data-ritual-card]')
  );

  const current = section.querySelector('[data-ritual-current]');
  const total = section.querySelector('[data-ritual-total]');
  const progress = section.querySelector('[data-ritual-progress]');

  if (!slider || cards.length === 0) {
    return;
  }

  const sliderRect = slider.getBoundingClientRect();

  let activeIndex = 0;
  let closestDistance = Infinity;

  cards.forEach((card, index) => {
    const cardRect = card.getBoundingClientRect();

    const distance = Math.abs(
      cardRect.left - sliderRect.left
    );

    if (distance < closestDistance) {
      closestDistance = distance;
      activeIndex = index;
    }
  });

  if (current) {
    current.textContent = String(
      activeIndex + 1
    ).padStart(2, '0');
  }

  if (total) {
    total.textContent = String(
      cards.length
    ).padStart(2, '0');
  }

  if (progress) {
    const percentage =
      ((activeIndex + 1) / cards.length) * 100;

    progress.style.width = `${percentage}%`;
  }
}

function debounceSkincareRitual(callback, delay) {
  let timeout;

  return function () {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      callback();
    }, delay);
  };
}